import styled from 'styled-components';

import { StyledContainerProps } from './StyledRow';

export const StyledColumn = styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '1.1rem'};
  height: ${(props) => props.height || 'auto'};
  width: ${(props) => props.width || 'auto'};
`;
